/* PILSNERISH OS — product page: variants, tall sticky buy box, cart, mobile sticky ATC. The gallery is pz-gallery.js (R5). */
(function () {
  'use strict';
  var w = window, d = document;
  var PZ = w.PZ;
  if (!PZ || !PZ.onSection) return;

  PZ.onSection('product', function (el) {
    var offs = [];
    function on(t, ev, fn, opt) { t.addEventListener(ev, fn, opt); offs.push(function () { t.removeEventListener(ev, fn, opt); }); }
    var dataEl = el.querySelector('[data-pz-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var form = el.querySelector('form[data-pz-form]') || el.querySelector('form[id^="pz-pf"]');
    var idInput = el.querySelector('[data-pz-variant-input]');
    var radios = Array.prototype.slice.call(el.querySelectorAll('[data-pz-opt]'));
    var priceAmt = el.querySelector('[data-pz-price-amt]');
    var priceWas = el.querySelector('[data-pz-price-was]');
    var saleTag = el.querySelector('[data-pz-sale]');
    var status = el.querySelector('[data-pz-status]');
    var atc = el.querySelector('[data-pz-atc]');
    var atcLabel = el.querySelector('[data-pz-atc-label]');
    var msg = el.querySelector('[data-pz-buy-msg]');
    var notify = el.querySelector('[data-pz-notify]');
    var dyn = el.querySelector('[data-pz-dyn]');
    var mini = el.querySelector('[data-pz-price-mini]');
    var sticky = el.querySelector('[data-pz-sticky-atc]');
    var stickyBtn = el.querySelector('[data-pz-sticky-add]');
    var miniWas = el.querySelector('[data-pz-was-mini]');
    var miniStock = el.querySelector('[data-pz-stock-mini]');
    var checkStickyRef = null;
    /* R15: the buy area starts at the first option picker; while all of it is still below the screen the bar's button
       scrolls to the picker (PICK SIZE) instead of adding the preselected size */
    var picker = el.querySelector('.pz-opt');
    var pickName = picker ? ((picker.querySelector('legend') || {}).textContent || '').split(':')[0].trim().toUpperCase() : '';
    var stBelow = false;
    function stickyLabel() {
      if (!stickyBtn) return;
      stickyBtn.textContent = !(current && current.available) ? 'NOTIFY ME' : (picker && stBelow ? 'PICK ' + (pickName || 'OPTION') : 'ADD TO CART');
    }
    var gallery = el.querySelector('[data-pz-gallery]');
    var info = el.querySelector('.pz-pdp__info');
    var qtyInput = el.querySelector('[data-pz-qty-input]');
    var mqDesk = w.matchMedia('(min-width: 990px)');
    var current = null;
    if (idInput) variants.forEach(function (v) { if (String(v.id) === idInput.value) current = v; });
    if (!current) current = variants[0] || null;

    /* ---------- variant logic ---------- */
    function selectedOptions() {
      var sel = [];
      radios.forEach(function (r) { if (r.checked) sel[parseInt(r.getAttribute('data-pz-opt'), 10)] = r.value; });
      return sel;
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (sel[j] != null && v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function refreshPills(sel) {
      radios.forEach(function (r) {
        var i = parseInt(r.getAttribute('data-pz-opt'), 10);
        var test = sel.slice(); test[i] = r.value;
        var avail = variants.some(function (v) {
          return v.available && test.every(function (val, j) { return val == null || v.options[j] === val; });
        });
        var label = r.closest('.pz-pill');
        if (label) label.classList.toggle('is-out', !avail);
      });
      el.querySelectorAll('.pz-opt').forEach(function (fs, i) {
        var span = fs.querySelector('[data-pz-opt-val]');
        if (span && sel[i] != null) span.textContent = sel[i];
      });
    }
    function setStatus(v) {
      if (!status) return;
      var anyAvail = variants.some(function (x) { return x.available; });
      /* R6: per-variant label from snippets/pz-stock (v.stock / v.stone, rendered server-side; no raw quantities) */
      if (v && v.available) status.innerHTML = '<span class="pz-st--' + esc(v.stone || 'in') + ((v.stone || 'in') === 'in' ? ' pz-green' : '') + '">[' + esc(v.stock || 'IN STOCK') + ']</span>' + (status.getAttribute('data-text-in') ? ' ' + esc(status.getAttribute('data-text-in')) : '');
      else if (anyAvail) status.innerHTML = '<span class="pz-red">[SOLD OUT]</span> ' + esc(status.getAttribute('data-text-var'));
      else status.innerHTML = '<span class="pz-red">[SOLD OUT]</span> ' + esc(status.getAttribute('data-text-out'));
    }
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function atcText(v) { return v ? (v.available ? 'ADD TO CART' : 'SOLD OUT') : 'UNAVAILABLE'; }
    /* R15: a hover scramble still running on click used to keep writing glyphs over ADDING... */
    function setAtc(t) { if (!atcLabel) return; if (PZ.unscramble) PZ.unscramble(atcLabel); atcLabel.textContent = t; }

    function applyVariant(v, opts) {
      opts = opts || {};
      current = v;
      if (idInput) idInput.value = v ? v.id : '';
      if (priceAmt && v) PZ.scramble(priceAmt, { text: PZ.money(v.price), accent: 'var(--red)' });
      if (priceWas) {
        if (v && v.compare > v.price) { priceWas.hidden = false; priceWas.textContent = PZ.money(v.compare); }
        else priceWas.hidden = true;
      }
      /* R4: green [SALE] stamp only for an available variant with compare-at > price */
      if (saleTag) saleTag.hidden = !(v && v.available && v.compare > v.price);
      setStatus(v);
      if (atc) {
        atc.disabled = !(v && v.available);
        setAtc(atcText(v));
      }
      if (notify) notify.hidden = !!(v && v.available);
      if (dyn) dyn.hidden = !(v && v.available);
      if (mini && v) mini.textContent = PZ.money(v.price);
      if (miniWas) { miniWas.hidden = !(v && v.compare > v.price); if (v && v.compare > v.price) miniWas.textContent = PZ.money(v.compare); }
      /* R6: the bar carries the PDP's label for the selected variant, sale combined like snippets/pz-stock
         (SALE, SALE · N LEFT, SALE · LOW STOCK, N LEFT, LOW STOCK, IN STOCK, SOLD OUT) from v.stone / v.stock */
      if (miniStock) {
        var mt = 'sold', ml = 'SOLD OUT';
        if (v && v.available) {
          var stone = v.stone || 'in', stock = v.stock || 'IN STOCK';
          if (v.compare > v.price) { mt = 'sale'; ml = stone === 'in' ? 'SALE' : 'SALE · ' + stock; }
          else { mt = stone; ml = stock; }
        }
        miniStock.className = 'pz-st--' + mt + (mt === 'in' ? ' pz-green' : '');
        miniStock.textContent = '[' + ml + ']';
      }
      if (checkStickyRef) checkStickyRef();
      stickyLabel();
      if (v && !opts.silent) {
        try {
          var u = new URL(w.location.href);
          u.searchParams.set('variant', v.id);
          w.history.replaceState({}, '', u.toString());
        } catch (e) {}
        /* R5: the gallery jumps to the variant's image */
        if (v.media && gallery) gallery.dispatchEvent(new CustomEvent('pz:media', { detail: { id: v.media } }));
      }
    }

    radios.forEach(function (r) {
      on(r, 'change', function () {
        var sel = selectedOptions();
        refreshPills(sel);
        applyVariant(findVariant(sel));
      });
    });
    if (radios.length) refreshPills(selectedOptions());

    /* ---------- qty ---------- */
    el.querySelectorAll('[data-pz-qty-step]').forEach(function (b) {
      on(b, 'click', function () {
        if (!qtyInput) return;
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-pz-qty-step'), 10);
        qtyInput.value = Math.max(1, n);
      });
    });

    /* ---------- add to cart ---------- */
    if (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        if (!current || !current.available || !PZ.cart) return;
        atc.setAttribute('aria-busy', 'true');
        atc.disabled = true;
        setAtc('ADDING...');
        if (msg) { msg.textContent = ''; msg.classList.remove('is-err'); }
        PZ.cart.add(current.id, qtyInput ? qtyInput.value : 1).then(function () {
          setAtc('ADD TO CART');
          atc.disabled = false;
          atc.removeAttribute('aria-busy');
          PZ.cart.open();
        }).catch(function (err) {
          atc.disabled = false;
          atc.removeAttribute('aria-busy');
          setAtc('ADD TO CART');
          if (msg) { msg.textContent = '[ERR] ' + (err && err.message ? err.message.toLowerCase() : 'could not add'); msg.classList.add('is-err'); }
        });
      });
    }
    if (atc && atcLabel && PZ.hover) {
      on(atc, 'mouseenter', function () { if (!atc.disabled) PZ.scramble(atcLabel, { text: 'DO IT', accent: 'var(--red)' }); });
      on(atc, 'mouseleave', function () { if (!atc.disabled) PZ.scramble(atcLabel, { text: atcText(current), accent: 'var(--red)' }); });
    }

    /* price scrambles in on load */
    if (priceAmt) PZ.scramble(priceAmt, { accent: 'var(--red)', duration: 420 });

    /* ---------- tall buy box: sticky that scrolls until its bottom is 20px above the viewport ---------- */
    var cur = null, lastY = w.scrollY;
    function place(dy) {
      if (!info) return;
      if (!mqDesk.matches) { info.style.top = ''; return; }
      var top0 = PZ.headerOffset();
      var h = info.offsetHeight, vh = w.innerHeight;
      if (h + top0 <= vh) { cur = top0; info.style.top = top0 + 'px'; return; }
      var min = vh - h - 20;
      if (cur == null) cur = top0;
      cur = Math.max(min, Math.min(top0, cur - (dy || 0)));
      info.style.top = cur + 'px';
    }
    on(w, 'scroll', function () { var y = w.scrollY; var dy = y - lastY; lastY = y; place(dy); }, { passive: true });
    on(w, 'resize', function () { place(0); });
    on(d, 'pz:header', function () { place(0); });
    if ('ResizeObserver' in w && info) { var ro = new ResizeObserver(function () { place(0); }); ro.observe(info); offs.push(function () { ro.disconnect(); }); }
    place(0);

    /* ---------- mobile sticky buy bar (R5) ----------
       Shown only while the main buy button is off screen (above or below: on a phone the whole first screen can be
       gallery + title), hidden while the cart, menu or MAIL.EXE is open (html.pz-locked / pz-mm-lock). The target is
       ADD TO CART for an available variant, else the NOTIFY window. html.pz-sticky-buy flags the bar for other UI.
       R15: the bar shows only while the whole buy area (option pickers through the button) is off screen, so it never
       covers the size pills. */
    if (sticky) {
      var root = d.documentElement;
      var stOn = null, stTick = 0;
      var buyTarget = function () {
        if (current && current.available && atc && atc.offsetParent) return atc;
        if (notify && !notify.hidden) return notify;
        return atc && atc.offsetParent ? atc : null;
      };
      var checkSticky = function () {
        stTick = 0;
        var t = buyTarget(), show = false, below = false;
        if (t && !mqDesk.matches && !root.classList.contains('pz-locked') && !root.classList.contains('pz-mm-lock')) {
          var r = t.getBoundingClientRect();
          var top = picker ? Math.min(r.top, picker.getBoundingClientRect().top) : r.top;
          below = top >= w.innerHeight;
          show = r.bottom <= PZ.headerOffset() + 4 || below;
        }
        if (below !== stBelow) { stBelow = below; stickyLabel(); }
        if (show === stOn) return;
        stOn = show;
        sticky.classList.toggle('is-on', show);
        root.classList.toggle('pz-sticky-buy', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      checkStickyRef = function () { if (!stTick) stTick = requestAnimationFrame(checkSticky); };
      on(w, 'scroll', checkStickyRef, { passive: true });
      on(w, 'resize', checkStickyRef);
      if ('MutationObserver' in w) {
        var mo = new MutationObserver(checkStickyRef);
        mo.observe(root, { attributes: true, attributeFilter: ['class'] });
        offs.push(function () { mo.disconnect(); root.classList.remove('pz-sticky-buy'); });
      }
      checkSticky();
      if (stickyBtn) on(stickyBtn, 'click', function () {
        if (current && current.available && picker && stBelow) {
          PZ.scrollTo(picker);
        } else if (current && current.available && form) {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        } else if (notify) {
          PZ.scrollTo(notify);
          var inp = notify.querySelector('input[type=email]');
          if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 500);
        }
      });
    }

    /* keep notify window open after a posted form */
    if (notify && notify.querySelector('[data-pz-posted], .pz-form-msg--err')) notify.hidden = false;

    return function () { offs.forEach(function (f) { try { f(); } catch (e) {} }); };
  });
})();
